<template>
  <el-dialog :visible.sync="form_state" title="Массовая смена статусов" :append-to-body="true" width="450px">
    <div v-loading="form.busy">
      <div class="form-row">
        <div class="form-group col-12">
          <label class="mb-1" :for="'status' + _uid">Статус</label>
          <Select2 v-model="status" :options="statuses_select" :id="'status'" :settings="{width: '100%'}" :class="{ 'has-error': form.errors.has('status') }"/>
          <has-error :form="form" field="status"/>
        </div>
        <div class="form-group col-12">
          <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='Нет'
              title="Уверены что хотите сменить статусы?"
              @confirm="update"
          >
            <button slot="reference" type="button" class="btn btn-primary" :class="{'btn-loading': form.busy, }">Обновить ({{ ids.length }})</button>
          </el-popconfirm>

        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Form from "vform";
import toastr from "toastr";
import RequestStatusData from "../../../plugins/request_status_data";
import RoleData from "../../../plugins/role_data";

export default {
  name: "ChangeStatus",
  data: () => ({
    ids: [],
    status: null,
    form_state: false,
    form: new Form(),
  }),
  mounted() {
    let self = this;
    this.$bus.$on('changeStatusBulk:open-form', ids => {
      self.ids = ids;
      self.form_state = true;
    });
  },
  beforeDestroy() {
    this.$bus.$off('changeStatusBulk:open-form');
  },
  computed: {
    statuses_select() {
      let data = RequestStatusData.forSelect();
      let user = this.$store.getters['auth/user'];
      data = data.filter(s => {
        return RoleData.hasPermissionStatus(user, 'request_status', s.id)
      });
      return data;
    },
  },
  watch: {
    form_state(val) {
      this.resetData();
    }
  },
  methods: {
    async update() {
      let self = this;
      if (this.validate()) {
        this.form.status = this.status;
        this.form.ids = this.ids;

        this.form.post('/api/requests/changeStatusBulk')
            .then(r => {
              self.$message.success({
                message: 'Успешно обновлено',
                duration: 2000,
              });
              self.resetData();
              self.form_state = false;
            });
      }
    },
    resetData() {
      this.status = null;
      this.form = new Form();
    },
    validate: function () {
      this.form = new Form();
      // if (!this.status) {
      //   this.form.errors.set('status', ['Выберите статус']);
      //   return false;
      // }
      return true;
    },
  }
}
</script>

<style scoped>

</style>
